import Box from '@mui/material/Box';
import PickUp from '../Pickup/Pickup';
import React from 'react';
import { useEffect, useState } from 'react';
import { loginPageStyles } from '../../../styles';
import QrCodeIcon from '@mui/icons-material/QrCode';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { EmptyStatesForTab } from '.';
import { RECORDS_STATUS } from '../../../Constants';

const LogisticsTabData = React.forwardRef((props, lastElementRef) => {
  const classes = loginPageStyles();
  const [assignedPractices, setAssignedPractices] = useState([]);
  const [enRoutedPractices, setEnRoutedPractices] = useState([]);
  const navigate = useNavigate();

  /*
  UseEffect for keeping track of assigned practices
  So when ever, practice is enrouted it will update states
  */

  useEffect(() => {
    setAssignedPractices(() => {
      return props.assignedPractices;
    });
  }, [props.assignedPractices]);

  /*
  UseEffect for keeping track of Enrouted practices
  So when ever, practice is enrouted it will update states
  */
  useEffect(() => {
    setEnRoutedPractices(() => {
      return props.enroutedPractices;
    });
  }, [props.enroutedPractices]);

  return enRoutedPractices.length === 0 && assignedPractices.length === 0 ? (
    <EmptyStatesForTab
      title={RECORDS_STATUS[props.tabIndex]?.title}
      description={RECORDS_STATUS[props.tabIndex]?.description}
    />
  ) : (
    <Box sx={{ mt: '-1px' }}>
      <Box
        sx={{
          bgcolor: '#054E8B',
          display: 'flex',
          padding: '4px 20px',
          color: '#FAFAFA',
          justifyContent: 'space-between',
          lineHeight: '20px',
          fontSize: '15px',
        }}
      >
        <Box
          className={classes.heading10}
          sx={{
            fontWeight: '700',
            textAlign: 'end',
            pt: '16px',
          }}
        >
          Current Pick Up
        </Box>
        {enRoutedPractices.length > 0 && (
          <Box onClick={() => navigate('/collect_order')} sx={{ pt: '8px' }}>
            <QrCodeIcon />
          </Box>
        )}
      </Box>
      <PickUp
        practiceOrdersData={enRoutedPractices}
        locationCoordinates={props.locationCoordinates}
        currentValue="En-route"
        distance={true}
        dropDownHeight={props?.dropDownHeight}
        setDropDownHeight={props?.setDropDownHeight}
        apply={props.apply}
        setApply={props.setApply}
        ref={null}
        tabIndex={props.tabIndex}
      />
      <Box
        sx={{
          bgcolor: '#EBEFF5',
          display: 'flex',
          padding: '4px 20px',
        }}
      >
        <Box
          className={classes.heading10}
          sx={{
            color: '#455066',
            fontWeight: '700',
            fontSize: '15px',
            textAlign: 'end',
            lineHeight: '20px',
            pt: '16px',
          }}
        >
          Next Locations
        </Box>
      </Box>
      <Box
        sx={{
          height:
            enRoutedPractices.length === 0
              ? 'calc(100vh - 292px)'
              : 'calc(100vh - 380px)',
          overflow: 'auto',
        }}
      >
        <PickUp
          practiceOrdersData={assignedPractices}
          locationCoordinates={props.locationCoordinates}
          currentValue="Assigned"
          distance={true}
          apply={props.apply}
          setApply={props.setApply}
          dropDownHeight={props.dropDownHeight}
          setDropDownHeight={props.setDropDownHeight}
          ref={lastElementRef}
          tabIndex={props.tabIndex}
        />
      </Box>
    </Box>
  );
});
LogisticsTabData.displayName = 'LogisticTabData';
LogisticsTabData.propTypes = {
  apply: PropTypes.bool.isRequired,
  setApply: PropTypes.func.isRequired,
  dropDownHeight: PropTypes.bool.isRequired,
  setDropDownHeight: PropTypes.func.isRequired,
  locationCoordinates: PropTypes.object,
  assignedPractices: PropTypes.array.isRequired,
  enroutedPractices: PropTypes.array.isRequired,
  tabIndex: PropTypes.number.isRequired,
};
export default LogisticsTabData;
